import React from 'react';
import Icon from './Icon';

const DeleteIcon = (props) => (
    <Icon {...props}>
        <path
            d="M13 19H5C3.9 19 3 18.1 3 17V7C3 5.9 3.9 5 5 5H19C20.1 5 21 5.9 21 7V12M7 9H13M7 13H10M15 15L21 21M21 15L15 21"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default DeleteIcon;
